import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import '../../sass/components/_components.footerBanner.scss';

const FooterBanner = () => {
    return (
        <div className="cp-footerBanner" style={{ backgroundColor: `#362370` }}>
            <div className="cp-footerBanner__inner" style={{ maxWidth: `1300px` }}>
                <h2>Get Started with Planful</h2>
                <ul className="l--flex">
                    <li className="l--flex"><StaticImage src='../../images/footer-banner-icon.svg' alt="LinkedIn" /><span>How much time will you save?</span></li>
                    <li className="l--flex"><StaticImage src='../../images/footer-banner-icon.svg' alt="LinkedIn" /><span>How will your finance team evolve?</span></li>
                    <li className="l--flex"><StaticImage src='../../images/footer-banner-icon.svg' alt="LinkedIn" /><span>Where will technology support you?</span></li>
                </ul>
                <div className="cp-footerBanner__buttons">
                    <a href="/resources/on-demand-webinars/planful-live-demo/" className="l-button">Watch demo</a>
                    <a href="/contact-us/" className="l-button">Contact Us</a>
                </div>
            </div>
        </div>
    )
}

export default FooterBanner;